import _taggedTemplateLiteral from "/codebuild/output/src997666004/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: ", "px;\n  top: 20px;\n  color: ", ";\n  width: 17px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  border-radius: 1px;\n  height: ", "px;\n  border: 1px solid ", ";\n  padding: ", "px ", "px ", "px ", "px;\n  appearance: none;\n\n  &:focus {\n    border-bottom: 2px solid ", ";\n    outline: 0;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      ", " {\n        opacity: 0;\n        position: absolute;\n      }\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from "styled-components";
import { colors, size, typography } from "../../shared/constants";
import { DownCaret } from "../Icons";
export var Label = styled.label(_templateObject(), typography.bodyText);
export var Wrapper = styled.div.attrs(function (o) {
  return {
    hideLabel: o.hideLabel
  };
})(_templateObject2(), function (_ref) {
  var o = _ref.hideLabel;
  return o && css(_templateObject3(), Label);
});
export var Select = styled.select(_templateObject4(), typography.bodyText, size.xl3, colors.gray3, size.xs1, size.xl2, size.sm, size.sm, colors.teal5);
export var Option = styled.option(_templateObject5());
export var DownArrow = styled(DownCaret)(_templateObject6(), size.md, colors.teal6);
export var SelectWrapper = styled.div(_templateObject7());